import React from "react";

export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex items-end justify-between mb-8" data-testid={testid}>
      <div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1 text-slate-500 text-sm">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
